var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.734357 0.370588C0.662708 0.441652 0.605838 0.526199 0.567029 0.619352C0.52822 0.712505 0.508239 0.812421 0.508239 0.913335C0.508239 1.01425 0.52822 1.11417 0.567029 1.20732C0.605839 1.30047 0.662708 1.38502 0.734357 1.45608L4.23546 4.95718C4.30711 5.02825 4.36398 5.11279 4.40279 5.20595C4.44159 5.2991 4.46158 5.39902 4.46158 5.49993C4.46158 5.60084 4.44159 5.70076 4.40279 5.79391C4.36398 5.88707 4.30711 5.97161 4.23546 6.04268L0.734358 9.54378C0.662708 9.61484 0.605839 9.69939 0.56703 9.79254C0.52822 9.88569 0.50824 9.98561 0.50824 10.0865C0.50824 10.1874 0.52822 10.2874 0.56703 10.3805C0.605839 10.4737 0.662708 10.5582 0.734358 10.6293C0.877584 10.7716 1.07133 10.8516 1.27328 10.8516C1.47523 10.8516 1.66898 10.7716 1.81221 10.6293L5.32095 7.12053C5.75041 6.69053 5.99163 6.10766 5.99163 5.49993C5.99163 4.8922 5.75041 4.30933 5.32095 3.87933L1.81221 0.370588C1.66898 0.228212 1.47523 0.148296 1.27328 0.148296C1.07133 0.148296 0.877583 0.228212 0.734357 0.370588Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e572e6706aec9cddc1df49f123073d4a.svg";
export { ForwardRef as ReactComponent };